// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Usuarios = lazy(() => import('../../views/pages/usuarios/lista'))
const Agentes = lazy(() => import('../../views/pages/agentes/index'))
const Tabs = lazy(() => import('../../views/pages/usuarios/Tabs'))

const UsuariosRoutes = [
  {
    element: <Usuarios />,
    path: '/usuarios/lista',
    meta: {
      appLayout: false,
      className: 'email-application',
      rol:'Administrador'
    }
  },
  {
    element: <Tabs />,
    path: '/usuarios/tabs',
    meta: {
      appLayout: false,
      className: 'email-application'
    }
  },
  {
    element: <Agentes />,
    path: '/agentes/lista',
    meta: {}
  }
]

export default UsuariosRoutes
